import React, { useState, useEffect } from 'react';

export default function CTAModal({ open, onClose, node, onSave }) {
  const [formData, setFormData] = useState({
    headerMessage: '',
    bodyMessage: '',
    footerMessage: '',
    buttonText: '',
    buttonUrl: '',
    delay: 0
  });

  useEffect(() => {
    if (open && node) {
      setFormData({
        headerMessage: node.data.headerMessage || '',
        bodyMessage: node.data.bodyMessage || '',
        footerMessage: node.data.footerMessage || '',
        buttonText: node.data.buttonText || '',
        buttonUrl: node.data.buttonUrl || '',
        delay: node.data.delay || 0
      });
    }
  }, [open, node]);

  const handleSave = () => {
    if (onSave) {
      onSave(node.id, formData);
    }
    onClose();
  };

  if (!open) return null;

  const modalStyle = {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    background: 'rgba(0,0,0,0.5)',
    zIndex: 10000,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '20px'
  };

  const contentStyle = {
    background: '#ffffff',
    borderRadius: '8px',
    padding: '24px',
    minWidth: '600px',
    maxWidth: '700px',
    maxHeight: '80vh',
    overflowY: 'auto',
    boxShadow: '0 4px 20px rgba(0,0,0,0.15)'
  };

  const inputStyle = {
    width: '100%',
    border: '1px solid #d1d5db',
    borderRadius: '4px',
    padding: '8px 12px',
    fontSize: '14px',
    marginBottom: '12px',
    outline: 'none'
  };

  const textareaStyle = {
    width: '100%',
    border: '1px solid #d1d5db',
    borderRadius: '4px',
    padding: '12px',
    fontSize: '14px',
    marginBottom: '12px',
    outline: 'none',
    minHeight: '80px',
    resize: 'vertical',
    fontFamily: 'inherit',
    position: 'relative'
  };

  const buttonStyle = {
    background: '#007bff',
    color: '#ffffff',
    border: 'none',
    borderRadius: '4px',
    padding: '8px 16px',
    fontSize: '14px',
    cursor: 'pointer',
    marginRight: '8px'
  };

  const secondaryButtonStyle = {
    background: '#6c757d',
    color: '#ffffff',
    border: 'none',
    borderRadius: '4px',
    padding: '8px 16px',
    fontSize: '14px',
    cursor: 'pointer'
  };

  const dynamicButtonStyle = {
    background: '#007bff',
    border: 'none',
    borderRadius: '4px',
    padding: '6px 12px',
    fontSize: '13px',
    cursor: 'pointer',
    marginRight: '8px',
    marginBottom: '8px',
    display: 'inline-flex',
    alignItems: 'center',
    gap: '4px',
    color: '#ffffff'
  };

  const nameButtonStyle = {
    background: '#f8f9fa',
    border: '1px dashed #d1d5db',
    borderRadius: '4px',
    padding: '6px 12px',
    fontSize: '13px',
    cursor: 'pointer',
    marginRight: '8px',
    marginBottom: '8px',
    display: 'inline-flex',
    alignItems: 'center',
    gap: '4px',
    color: '#495057'
  };

  const emojiButtonStyle = {
    position: 'absolute',
    top: '8px',
    right: '8px',
    background: 'none',
    border: 'none',
    fontSize: '16px',
    cursor: 'pointer',
    color: '#6c757d'
  };

  const googleButtonStyle = {
    position: 'absolute',
    bottom: '8px',
    right: '8px',
    background: '#34a853',
    border: 'none',
    borderRadius: '50%',
    width: '24px',
    height: '24px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: '12px',
    color: '#ffffff',
    cursor: 'pointer'
  };

  return (
    <div style={modalStyle} onClick={onClose}>
      <div style={contentStyle} onClick={e => e.stopPropagation()}>
        {/* Header */}
        <div style={{ textAlign: 'center', marginBottom: '20px' }}>
          <h2 style={{ margin: 0, color: '#495057', fontSize: '20px', fontWeight: '600' }}>
            Configure CTA URL Button
          </h2>
        </div>

        {/* Header Message Section */}
        <div style={{ marginBottom: '20px' }}>
          <label style={{ display: 'block', marginBottom: '8px', fontWeight: '500', color: '#495057' }}>
            Header Message
          </label>
          
          {/* Dynamic Content Buttons */}
          <div style={{ marginBottom: '12px' }}>
            <button style={dynamicButtonStyle}>
              <span>⚙️</span>
              <span>Custom</span>
              <span>▼</span>
            </button>
            <button style={nameButtonStyle}>
              <span>👤</span>
              <span>Name</span>
            </button>
          </div>

          {/* Header Message Textarea */}
          <div style={{ position: 'relative' }}>
            <textarea
              value={formData.headerMessage}
              onChange={e => setFormData(prev => ({ ...prev, headerMessage: e.target.value }))}
              placeholder="Enter header message..."
              style={textareaStyle}
            />
            <button
              style={emojiButtonStyle}
              onClick={() => {
                // Emoji picker functionality would go here
                console.log('Emoji picker clicked');
              }}
            >
              😊
            </button>
            <button
              style={googleButtonStyle}
              onClick={() => {
                // Google integration functionality would go here
                console.log('Google integration clicked');
              }}
            >
              G
            </button>
          </div>
        </div>

        {/* Body Message Section */}
        <div style={{ marginBottom: '20px' }}>
          <label style={{ display: 'block', marginBottom: '8px', fontWeight: '500', color: '#495057' }}>
            Body Message
          </label>
          
          {/* Dynamic Content Buttons */}
          <div style={{ marginBottom: '12px' }}>
            <button style={dynamicButtonStyle}>
              <span>⚙️</span>
              <span>Custom</span>
              <span>▼</span>
            </button>
            <button style={nameButtonStyle}>
              <span>👤</span>
              <span>Name</span>
            </button>
          </div>

          {/* Body Message Textarea */}
          <div style={{ position: 'relative' }}>
            <textarea
              value={formData.bodyMessage}
              onChange={e => setFormData(prev => ({ ...prev, bodyMessage: e.target.value }))}
              placeholder="Enter body message..."
              style={textareaStyle}
            />
            <button
              style={emojiButtonStyle}
              onClick={() => {
                // Emoji picker functionality would go here
                console.log('Emoji picker clicked');
              }}
            >
              😊
            </button>
          </div>
        </div>

        {/* Footer Message Section */}
        <div style={{ marginBottom: '20px' }}>
          <label style={{ display: 'block', marginBottom: '8px', fontWeight: '500', color: '#495057' }}>
            Footer Message
          </label>
          
          {/* Dynamic Content Buttons */}
          <div style={{ marginBottom: '12px' }}>
            <button style={dynamicButtonStyle}>
              <span>⚙️</span>
              <span>Custom</span>
              <span>▼</span>
            </button>
            <button style={nameButtonStyle}>
              <span>👤</span>
              <span>Name</span>
            </button>
          </div>

          {/* Footer Message Textarea */}
          <div style={{ position: 'relative' }}>
            <textarea
              value={formData.footerMessage}
              onChange={e => setFormData(prev => ({ ...prev, footerMessage: e.target.value }))}
              placeholder="Enter footer message..."
              style={textareaStyle}
            />
            <button
              style={emojiButtonStyle}
              onClick={() => {
                // Emoji picker functionality would go here
                console.log('Emoji picker clicked');
              }}
            >
              😊
            </button>
          </div>
        </div>

        {/* Button Text Section */}
        <div style={{ marginBottom: '20px' }}>
          <label style={{ display: 'block', marginBottom: '8px', fontWeight: '500', color: '#495057' }}>
            Button Text
          </label>
          
          {/* Dynamic Content Button */}
          <div style={{ marginBottom: '12px' }}>
            <button style={dynamicButtonStyle}>
              <span>⚙️</span>
              <span>Custom</span>
              <span>▼</span>
            </button>
          </div>

          {/* Button Text Input */}
          <input
            type="text"
            value={formData.buttonText}
            onChange={e => setFormData(prev => ({ ...prev, buttonText: e.target.value }))}
            placeholder="Enter button text..."
            style={inputStyle}
          />
        </div>

        {/* Button URL Section */}
        <div style={{ marginBottom: '20px' }}>
          <label style={{ display: 'block', marginBottom: '8px', fontWeight: '500', color: '#495057' }}>
            Button URL
          </label>
          
          {/* Dynamic Content Button */}
          <div style={{ marginBottom: '12px' }}>
            <button style={dynamicButtonStyle}>
              <span>⚙️</span>
              <span>Custom</span>
              <span>▼</span>
            </button>
          </div>

          {/* Button URL Input */}
          <input
            type="url"
            value={formData.buttonUrl}
            onChange={e => setFormData(prev => ({ ...prev, buttonUrl: e.target.value }))}
            placeholder="Enter button URL..."
            style={inputStyle}
          />
        </div>

        {/* Delay Setting */}
        <div style={{ marginBottom: '24px' }}>
          <label style={{ display: 'block', marginBottom: '8px', fontWeight: '500', color: '#495057' }}>
            Delay in reply - {formData.delay} sec
          </label>
          <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
            <input
              type="range"
              min="0"
              max="30"
              value={formData.delay}
              onChange={e => setFormData(prev => ({ ...prev, delay: parseInt(e.target.value) }))}
              style={{ flex: 1 }}
            />
            <span style={{ fontSize: '14px', color: '#6c757d', minWidth: '50px' }}>
              {formData.delay} sec
            </span>
          </div>
        </div>

        {/* Action Buttons */}
        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
          <button
            onClick={handleSave}
            style={{ ...buttonStyle, display: 'flex', alignItems: 'center', gap: '6px' }}
          >
            💾 Save
          </button>
          <button
            onClick={onClose}
            style={{ ...secondaryButtonStyle, display: 'flex', alignItems: 'center', gap: '6px' }}
          >
            ✕ Close
          </button>
        </div>
      </div>
    </div>
  );
} 